import uuid from 'node-uuid';

const notifications = (state = [], action) => {
  switch (action.type) {
    case 'ADD_NOTIFICATION': 
      return [
        ...state,
        {
          id: uuid(),
          text: action.text,
          style: action.style
        }
      ]

    case 'REMOVE_NOTIFICATION': 
      return state.filter((notification) => {
        if (notification.id === action.id) {
          return false;
        }
        return true;
      })

    default: 
      return state
  }
}
export default notifications


// WEBPACK FOOTER //
// ./src/reducers/notifications.js